import { getMypageNovelNovelIdFrontispiece } from "../../../api/v1/mypage/novel/[novel_id]/frontispiece/get"
import { MypageNovelNovelIdFrontispieceGetInputModel } from "../../../api/v1/mypage/novel/[novel_id]/frontispiece/GetInputModel"
import { Frontispiece } from "./Frontispiece"

export const fetchFrontispieces = (
  novelId: number,
): Promise<Frontispiece[]> => {
  return getMypageNovelNovelIdFrontispiece(
    new MypageNovelNovelIdFrontispieceGetInputModel({ novelId }),
  )
}
